import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  spinnerVisible = false;
  buttonSpinnerVisible = false;

  showSpinner() {
    this.spinnerVisible = true;
  }

  hideSpinner() {
    this.spinnerVisible = false;
    this.buttonSpinnerVisible = false;
  }

  showButtonSpinner() {
    this.buttonSpinnerVisible = true;
  }
}
